export default __webpack_public_path__ + "static/media/bathroom2.84435d48.png";